import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import { Col, Row } from "../Grid";
import Link from "../Link";
import Block from "../Block";
import { classes } from "../utils/classes";

const FooterNav = ({ className = "", ...props }) => (
	<Block className={classes("footer__nav", className)} {...props} />
);

FooterNav.propTypes = {
	...Block.propTypes,
};

export const FooterNavRow = ({ children, ...props }) => (
	<Row mx py {...props}>
		{children}
	</Row>
);

FooterNavRow.propTypes = {
	...Row.propTypes,
	children: node.isRequired,
};

export const FooterNavCol = ({
	sm = 6,
	md = "shrink",
	lg = "shrink",
	className = "",
	children,
}) => (
	<Col sm={sm} md={md} lg={lg} className={className}>
		{children}
	</Col>
);

FooterNavCol.propTypes = {
	sm: oneOf(["auto", "shrink", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	md: oneOf(["auto", "shrink", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	lg: oneOf(["auto", "shrink", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	className: string,
	children: node.isRequired,
};

export const FooterNavList = ({ className = "", children }) => {
	return <ul className={classes("footer__nav-list", className)}>{children}</ul>;
};

FooterNavList.propTypes = {
	className: string,
	children: node.isRequired,
};

export const FooterNavListItem = ({ enable = true, className = "", children }) =>
	enable ? <li className={classes("footer__nav-list_item", className)}>{children}</li> : null;
FooterNavListItem.propTypes = {
	enable: bool,
	className: string,
	children: node.isRequired,
};

export const FooterNavItemLink = ({
	children,
	className = "",
	href = "/",
	isBold = false,
	...props
}) => {
	return (
		<Link
			isBaseClassName={false}
			href={href}
			className={classes(
				"footer__nav-list_item-link",
				isBold && "footer__nav-list_item-link--bold",
				className,
			)}
			{...props}
		>
			{children}
		</Link>
	);
};

FooterNavItemLink.propTypes = {
	children: node.isRequired,
	href: string,
	isBold: bool,
	className: string,
};

export const FooterNavListTitle = ({ children }) => {
	return <div className="footer__nav-list_title">{children}</div>;
};

FooterNavListTitle.propTypes = {
	children: node.isRequired,
};

export const FooterNavTitleLink = ({ children, className = "", href = "/", ...props }) => {
	return (
		<Link
			isBaseClassName={false}
			href={href}
			className={classes("footer__nav-list_title-link", className)}
			{...props}
		>
			{children}
		</Link>
	);
};

FooterNavTitleLink.propTypes = {
	children: node.isRequired,
	href: string,
	className: string,
};

export default FooterNav;
